import { Form, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import AttributeForm from "../../../component/attributeForm";
import { useCookies } from "react-cookie";
import axiosInstance from "../../../utils/axios";

export default function AttributeManageDetail() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({});
  const params = useParams();
  const id = params?.id;
  const [cookies, setCookie, removeCookie] = useCookies(['admin']);

  const fetchAttribute = async () => {
    await axiosInstance.get(`/attribute/getById/${params?.id}`)
      .then((res) => {
        const data = res?.data?.data[0];
        const values = {
          ...data,
        };
        setInitialValues(values);
      });
  };

  const onSubmit = async (values) => {
    try {
      if (id && id !== "tao-moi") {
        await axiosInstance.post(`/attribute/update/${id}`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
            if(res?.data?.status == 1) navigate("/admin/quan-ly-thuoc-tinh");
          });
      } else {
        await axiosInstance.post(`/attribute/create`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
            console.log(res?.data?.status)
            if(res?.data?.status == 1) navigate("/admin/quan-ly-thuoc-tinh");
          });
      }
      
    } catch (error) {
      message.error(error);
    }
  };

  useEffect(() => {
    if (id && id !== "tao-moi") fetchAttribute();
    form.resetFields();
  }, [form, id]);

  return (
    <AttributeForm
      id={id !== "create" ? id : undefined}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  );
}
